var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEntryDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1317_6368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2559 1.69057L13.8915 1.67383C11.9814 1.67383 10.4187 3.18025 10.4187 5.02143V10.0428H13.8915V8.36903H31.2559V31.8022H13.8915V30.1284H10.4187V35.1498C10.4187 36.991 11.9814 38.4974 13.8915 38.4974H31.2559C33.1659 38.4974 34.7287 36.991 34.7287 35.1498V5.02143C34.7287 3.18025 33.1659 1.69057 31.2559 1.69057ZM17.3644 25.107H20.8373V13.3904H8.68222V16.738H14.916L5.20935 26.0946L7.65772 28.4546L17.3644 19.0981V25.107Z",
    fill: "#00AE9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1317_6368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6744,
    height: 40.1712,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryDocument);
export default __webpack_public_path__ + "static/media/entryDocument.0769b65de981c5b30c614a1c3650bc99.svg";
export { ForwardRef as ReactComponent };